export default __webpack_public_path__ + "static/media/102_mobile.0aa341bc.jpg";